// extracted by mini-css-extract-plugin
export default {"container":"Overview_container__tHM62","switchContainer":"Overview_switchContainer__H5biy","ModalIcon":"Overview_ModalIcon__e9hqZ","buttons":"Overview_buttons__do7ub"};